export default __webpack_public_path__ + "static/media/Publication.667555e1.svg";